import {
  HIDE_LOOM_PRO_VIDEO,
  SHOW_CONNECT_BUTTONS,
  SHOW_LOOM_PRO_VIDEO,
} from '../constants/actions';

export const showLoomProVideo = () => ({
  type: SHOW_LOOM_PRO_VIDEO,
});

export const hideLoomProVideo = () => ({
  type: HIDE_LOOM_PRO_VIDEO,
});

export const showConnectButtons = () => ({
  type: SHOW_CONNECT_BUTTONS,
});
